/**
 * Smooths out the hero's in-page anchor buttons (e.g. "Felfedezés" scrolling
 * down to the first card) specifically on a fresh page load.
 *
 * On a hard refresh, clicking an anchor link immediately can start the
 * native browser scroll-to-target before the page's layout has actually
 * settled — most commonly because the Paprika webfont hasn't swapped in
 * yet (font-display: swap reflows the whole page once it loads, already a
 * known CLS culprit on this project) — so the target's real position
 * shifts partway through the scroll, making it look harsh/discontinuous.
 * A second click, after everything has settled, animates cleanly.
 *
 * Waiting for the fonts to finish loading (with a timeout fallback, in
 * case fonts.ready never resolves) before starting the scroll keeps the
 * target position stable for the whole animation.
 */

const FONT_READY_TIMEOUT_MS = 800;

function waitForFontsReady() {
  if (!document.fonts || !document.fonts.ready) return Promise.resolve();

  return Promise.race([
    document.fonts.ready,
    new Promise((resolve) => setTimeout(resolve, FONT_READY_TIMEOUT_MS)),
  ]);
}

document.querySelectorAll('.hero a[href^="#"]').forEach((link) => {
  link.addEventListener('click', (event) => {
    const id = link.getAttribute('href').slice(1);
    const target = id ? document.getElementById(id) : null;

    if (!target) return;

    event.preventDefault();

    waitForFontsReady().then(() => {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
});
